<template>
  <div class="row align-justify">
    <div class="small-12 large-4 columns">
      <p v-dompurify-html="$t('APP.RELEASES.BUNDLE.SIGN_DESCRIPTION')" />

      <a v-if="aabLink" :href="aabLink" download class="link">
        <i class="el-icon-download" />
        {{ $t('APP.RELEASES.BUNDLE.DOWNLOAD_AAB') }}
      </a>
    </div>

    <div class="small-12 large-8 columns">
      <DroppableResumableUploader
        accept=".bin"
        :upload-url="uploadPath"
        @upload-done="onUploadDone"
      />
    </div>
  </div>
</template>

<script>
import DroppableResumableUploader from '@@/common/file-uploaders/DroppableResumableUploader';

export default {
  name: 'BundleSignUploader',
  components: { DroppableResumableUploader },

  props: {
    uploadPath: {
      type: String,
      required: true,
    },
    aabLink: {
      type: String,
      default: '',
    },
  },

  methods: {
    onUploadDone(responses = []) {
      this.$emit('upload-done', responses[0]);
    },
  },
};
</script>
